var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.loading
      ? _c("div", [_vm._v("loading...")])
      : _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "addresses-page" },
              [
                _vm._l(_vm.addresses, function(address, index) {
                  return _c("div", { staticClass: "address" }, [
                    address.default
                      ? _c("h2", [_c("b", [_vm._v("Default Address")])])
                      : _vm._e(),
                    _c("p", { attrs: { "aria-live": "polite" } }, [
                      _vm.addressUpdated
                        ? _c("b", [_vm._v("Your address has been updated.")])
                        : _vm._e()
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(address.first_name) +
                          " " +
                          _vm._s(address.last_name)
                      ),
                      address.address1 ? _c("br") : _vm._e(),
                      _vm._v(_vm._s(address.address1)),
                      address.address2 ? _c("br") : _vm._e(),
                      _vm._v(_vm._s(address.address2)),
                      _c("br"),
                      _vm._v(
                        _vm._s(address.city) +
                          " " +
                          _vm._s(address.province) +
                          " " +
                          _vm._s(address.zip)
                      ),
                      _c("br"),
                      _vm._v(_vm._s(address.country)),
                      address.phone ? _c("br") : _vm._e(),
                      _vm._v(_vm._s(address.phone))
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn--primary",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.editForm(index)
                          }
                        }
                      },
                      [_vm._v("Edit Address")]
                    ),
                    !address.default
                      ? _c(
                          "button",
                          {
                            staticClass: "btn--primary",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.makeDefault(index)
                              }
                            }
                          },
                          [_vm._v("Make Default")]
                        )
                      : _vm._e(),
                    !address.default
                      ? _c(
                          "button",
                          {
                            staticClass: "btn--primary",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.remove(index)
                              }
                            }
                          },
                          [_vm._v("Delete")]
                        )
                      : _vm._e()
                  ])
                }),
                _c(
                  "button",
                  {
                    staticClass: "btn--primary",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.newAddress.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("+")
                    ]),
                    _vm._v("Add Address")
                  ]
                )
              ],
              2
            ),
            _vm.showPopup
              ? _c("address-popup", {
                  attrs: { create: _vm.createNewAddress, address: _vm.address }
                })
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }